import React, { useState } from 'react';

import NavigationButton from '@atom/components/common/map/mapDrawerContent/NavigationButton';
import NavigationControls from '@atom/components/common/map/mapDrawerContent/NavigationControls';
import { Icon, IconButton, Progress } from '@atom/mui';
import colors from '@atom/styles/colors';
import { UserDetail } from '@atom/types/user';
import history from '@atom/utilities/history';
import userUtilities from '@atom/utilities/userUtilities';

import UserSummaryInfo from './UserSummaryInfo';
import UserSummaryWork from './UserSummaryWork';

import './userSummaryTray.css';

const views = [
  {
    value: 'info',
    icon: 'info',
  },
  {
    value: 'work',
    icon: 'work',
  },
];

interface Props {
  user?: UserDetail;
  loading?: boolean;
  workOrders?: any;
  onCancel: () => void;
}

const UserSummaryTray = ({ user, loading, workOrders, onCancel }: Props) => {
  const [activeView, setActiveView] = useState<string>('info');

  const getTrayContentBody = () => {
    switch (activeView) {
      case 'info': {
        return <UserSummaryInfo user={user} />;
      }
      case 'work': {
        return <UserSummaryWork work={workOrders} />;
      }
      default: {
        return <UserSummaryInfo user={user} />;
      }
    }
  };

  const navigateToTeamDetail = () => {
    if (user) {
      history.push(`/team/${user?.id}`);
    }
  };

  const body = getTrayContentBody();

  return (
    <div styleName="container">
      {loading ? (
        <div styleName="spinner-container">
          <Progress />
        </div>
      ) : (
        <div styleName="tray-container">
          <div styleName="header-container">
            <div styleName="exit-container">
              <IconButton onClick={onCancel}>
                <Icon color={colors.neutral.gray}>close</Icon>
              </IconButton>
            </div>
            <div styleName="profile-container">
              <div styleName="header-profile-image">
                <img styleName="profile-image" src={user.photoUrl} />
              </div>
              <div styleName="header-title-container">
                <div styleName="header-name">
                  {userUtilities.getUserFullName(user)}
                </div>
                <div styleName="header-subtext">{user.email}</div>
                <div styleName="header-subtext">{user.role}</div>
              </div>
            </div>
          </div>
          <div styleName="tray-content-container">
            <div styleName="summary-image-container" />
            <NavigationControls
              views={views}
              activeView={activeView}
              setActiveView={setActiveView}
            />
            <div>{body}</div>
          </div>
          <NavigationButton
            label="View Full Detail"
            onClick={navigateToTeamDetail}
          />
        </div>
      )}
    </div>
  );
};

export default UserSummaryTray;
